import { render } from "./MobileSidebar.vue?vue&type=template&id=5b5890a8"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script